import ContractsCargoTaxiListResponse, {
  ContractsCargoTaxiListResponseCargoCompany,
  ContractsCargoTaxiListResponseItem,
  ContractsCargoTaxiListResponseModel,
  ContractsCargoTaxiListResponseTaxiCorporation,
} from "../../../../api/raily/contracts/cargo-taxi/list/contracts-cargo-taxi-list.response";
import BillingModel from "../../../../types/billing-model";
import ContractsCargoTaxiList, {
  ContractsCargoTaxiListCargoCompany,
  ContractsCargoTaxiListItem,
  ContractsCargoTaxiListTaxiCorporation,
} from "./contracts-cargo-taxi-list";

const createModel = (
  model: ContractsCargoTaxiListResponseModel,
): BillingModel => {
  switch (model) {
    case ContractsCargoTaxiListResponseModel.AB:
      return BillingModel.AB;
    case ContractsCargoTaxiListResponseModel.ABA:
      return BillingModel.ABA;
    case ContractsCargoTaxiListResponseModel.OTHER:
      return BillingModel.OTHER;
    case ContractsCargoTaxiListResponseModel.SABS:
      return BillingModel.SABS;
  }
};

const createTaxiCorporation = (
  taxiCorporation: ContractsCargoTaxiListResponseTaxiCorporation,
): ContractsCargoTaxiListTaxiCorporation => {
  return {
    companyName: taxiCorporation.companyName,
  };
};

const createCargoCompany = (
  cargoCompany: ContractsCargoTaxiListResponseCargoCompany,
): ContractsCargoTaxiListCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createDataItem = (
  item: ContractsCargoTaxiListResponseItem,
): ContractsCargoTaxiListItem => {
  return {
    allowChargeDuringRide: item.allowChargeDuringRide,
    allowChargeWhileApproaching: item.allowChargeWhileApproaching,
    allowChargeWhileReturning: item.allowChargeWhileReturning,
    cargoCompany: createCargoCompany(item.cargoCompany),
    discountLimit: item.discountLimit,
    distanceRate: item.distanceRate,
    haltingTimeAfterMinutes: item.haltingTimeAfterMinutes,
    haltingTimeRate: item.haltingTimeRate,
    id: item.id,
    model: createModel(item.model),
    publishingAllowed: item.publishingAllowed,
    taxiCorporation: createTaxiCorporation(item.taxiCorporation),
    validSince: item.validSince,
    validTo: item.validTo,
    isValid: item.isValid,
  };
};

const createData = (
  responseData: ContractsCargoTaxiListResponseItem[],
): ContractsCargoTaxiListItem[] => {
  const items: ContractsCargoTaxiListItem[] = responseData.map(createDataItem);

  const activeContracts = items.filter((contract) => contract.isValid);
  const inactiveContracts = items.filter((contract) => !contract.isValid);

  return [...activeContracts, ...inactiveContracts];
};

const create = (
  response: ContractsCargoTaxiListResponse,
): ContractsCargoTaxiList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const contractsCargoTaxiListFactory = {
  create,
};

export default contractsCargoTaxiListFactory;
